import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=50721ec5&"
import script from "./editTable.vue?vue&type=script&lang=js&"
export * from "./editTable.vue?vue&type=script&lang=js&"
import style0 from "./editTable.vue?vue&type=style&index=0&id=50721ec5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports